import { Inject, Injectable, OnDestroy } from '@angular/core';
import { PureAbility } from '@casl/ability';
import { AbilityService } from '@casl/angular';
import {
  Configuration,
  ConfigurationId,
} from '@daas-consulting/production/shared/cross/configuration';
import * as store from '@daas-consulting/production/shared/frontend/store';
import { LayoutMedicsPageViewContract } from '@daas-consulting/production/shared/frontend/view_contracts';
import { Select } from '@ngxs/store';
import { BehaviorSubject, Observable, Subject, takeUntil } from 'rxjs';

@Injectable()
export class LayoutMedicsPageViewModel
  implements LayoutMedicsPageViewContract, OnDestroy
{
  @Select(store.loader.selectors.LoaderSelectors.isLoading)
  isLoading$!: Observable<boolean>;
  name$!: Observable<string>;
  email$!: Observable<string>;
  picture$!: Observable<string>;
  readonly #showCreatePrescription$: BehaviorSubject<boolean> =
    new BehaviorSubject(false);
  readonly #showListPrescription$: BehaviorSubject<boolean> =
    new BehaviorSubject(false);
  readonly #showListPatient$: BehaviorSubject<boolean> = new BehaviorSubject(
    false
  );
  readonly #destroy$: Subject<void> = new Subject<void>();
  readonly #version$: BehaviorSubject<string> = new BehaviorSubject('0.0.0');

  constructor(
    abilityService: AbilityService<PureAbility>,
    @Inject(ConfigurationId) configuration: Configuration
  ) {
    abilityService.ability$
      .pipe(takeUntil(this.#destroy$))
      .subscribe((ability) => {
        const listPatient = ability.can('list', 'patients.patients.patient');
        this.#showListPatient$.next(listPatient);
        const createPrescription = ability.can(
          'create',
          'prescriptions.prescriptions.prescription'
        );
        this.#showCreatePrescription$.next(createPrescription);
        const listPrescription = ability.can(
          'list',
          'prescriptions.prescriptions.prescription'
        );
        this.#showListPrescription$.next(listPrescription);
      });
    this.#version$.next(configuration.version);
  }

  get showCreatePrescription$(): Observable<boolean> {
    return this.#showCreatePrescription$.asObservable();
  }

  get showListPrescription$(): Observable<boolean> {
    return this.#showListPrescription$.asObservable();
  }

  get version$(): Observable<string> {
    return this.#version$.asObservable();
  }

  get showListPatient$(): Observable<boolean> {
    return this.#showListPatient$.asObservable();
  }

  ngOnDestroy(): void {
    this.#destroy$.next();
    this.#destroy$.complete();
  }

  async logout(): Promise<void> {
    // await this.#authenticationService.logout();
  }
}
